
define(
	'GoVirtualOffice.MyAccountStandalone.MyAccountStandalone.View',
    [
        'Backbone',
        'govirtualoffice_myaccountstandalone_myaccountstandalone.tpl'
    ],
    function (
        Backbone,
        govirtualoffice_myaccountstandalone_myaccountstandalone_tpl
    )
{
	'use strict';

	return  Backbone.View.extend({

        template: govirtualoffice_myaccountstandalone_myaccountstandalone_tpl,

        initialize: function (options) {

            this.on('afterViewRender', function () {
                Backbone.history.location.assign(options.redirect);
            });
        }
	});
});
